// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import cx from 'classnames';

interface KareMultiselectCheckboxProps {
    onClick?: any;
    isChecked?: boolean;
    label?: string;
}

/* Creates and styles a checkbox with custom text */

/* TODO(joaonoronha): Change component behavior to actually accept Multiple
 * checkboxes or rename to KareCheckbox, check if component isolation is
 * actually needed.
 */
export class KareMultiselectCheckbox extends React.Component<KareMultiselectCheckboxProps> {
    render() {
        const {isChecked, onClick, label} = this.props;
        const className = cx('kare-multiselect-checkbox', {
            'kare-multiselect-checkbox--checked': isChecked,
        });
        return (
            <label onClick={onClick} className={className}>
                <div className="kare-multiselect-checkbox__ui-outer">
                    <div className="kare-multiselect-checkbox__ui-inner" />
                </div>
                <span>{label}</span>
            </label>
        );
    }
}

interface KareMultiselectCheckboxForReduxFormProps {
    label: string;
    input: any;
    disabled: boolean;
}

export class KareMultiselectCheckboxForReduxForm extends React.Component<KareMultiselectCheckboxForReduxFormProps> {
    render() {
        const {input, label} = this.props;
        const className = cx('kare-multiselect-checkbox', {
            'kare-multiselect-checkbox--checked': !!input.checked,
        });

        return (
            <label className={className}>
                {label}
                <div
                    className="kare-multiselect-checkbox__ui-outer"
                    onClick={() => {
                        input.onChange(!input.checked);
                    }}
                >
                    <div className="kare-multiselect-checkbox__ui-inner" />
                </div>
            </label>
        );
    }
}
